import LoadMorePresentation from './LoadMorePresentation';

interface loadMoreContainerProps {
  loadedDataLength: number;
  limit: number;
  isLoading: boolean;
  pageNumber?: number;
  onChange: () => void;
}
const LoadMoreContainer = ({
  loadedDataLength,
  limit,
  isLoading,
  onChange
}: loadMoreContainerProps) => {
  return (
    <LoadMorePresentation
      loadedDataLength={loadedDataLength}
      limit={limit}
      handleLoadMore={onChange}
      isLoading={isLoading}
    />
  );
};

export default LoadMoreContainer;
